let config = {};
let enviroment = '';


if (window.location.href.indexOf('localhost') >= 0) {
	enviroment = 'dev';
} else if (window.location.href.indexOf('gnre-homol.econeteditora.com.br/') >= 0) {
	enviroment = 'homolog';
} else if (window.location.href.indexOf('ec2-34-206-89-100.compute-1.amazonaws.com:8082') >= 0) {
	enviroment = 'hotfix';
} else {
	enviroment = 'prod';
}



// enviroment = 'homolog';

switch (enviroment) {
	case 'dev':
		config = {
			urls: {
				SOCKET_CONNECT: 'http://localhost:8000?Ambiente=localhost',
				API_URL_DEBUG: 'http://localhost:3001',
				API_URL_BASE: 'http://localhost:57767/api/',
				//API_URL_BASE: 'http://econetgnre-env.us-east-1.elasticbeanstalk.com/api/'
			},
		};

		break;

	case 'prod':
		config = {
			urls: {
				SOCKET_CONNECT: 'http://54.156.29.195:3000?Ambiente=producao',
				API_URL_BASE: 'https://gnre-api.econeteditora.com.br/api/',
			},
		};

		break;

	case 'hotfix':
		config = {
			urls: {
				SOCKET_CONNECT: 'http://34.206.89.100:3010?Ambiente=hotfix',
				API_URL_BASE: 'http://ecoauditbasewebserv-hotfix.us-east-1.elasticbeanstalk.com/api/',
			},
		};

		break;

	case 'homolog':
	default:
		config = {
			urls: {
				SOCKET_CONNECT: 'http://34.206.89.100:3000?Ambiente=homologacao',
				API_URL_BASE: 'https://gnre-api-homol.econeteditora.com.br/api/',
			},
		};

		break;
}

export default config;
